import { createSelector } from '@reduxjs/toolkit'

import { getOpDay as getOpDayRoot } from '../root.selectors'

export const getOpDay = createSelector(getOpDayRoot, (slice) => slice.base)
export const getProceedToDay = createSelector(getOpDayRoot, (slice) => slice.proceedToDay)
